// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@flip/App/Components/Common/XngZone";
import { DivWrapper } from "@flip/XDL/constants";
import { xScreen } from "@flip/XDL/Utilities";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";
import { css } from "styled-components";

interface AddressPageLayoutStyles {
    container?: GridContainerProps;
    addressInfoGridItem?: GridItemProps;
    addressBookGridItem?: GridItemProps;
}

const addressPageLayoutStyles: AddressPageLayoutStyles = {
    container: {
        gap: 30,
    },
    addressInfoGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            & > ${DivWrapper} {
                display: flex;
                flex-direction: column;
                gap: 30px;
                ${xScreen("lte", "sm")} {
                    flex-direction: row;
                    justify-content: space-between;
                }
                ${xScreen("lt", "sm")} {
                    flex-direction: column;
                    justify-content: flex-start;
                }
            }
        `,
    },
    addressBookGridItem: {
        width: [12, 12, 8, 8, 8],
        css: css`
            display: flex;
            flex-direction: column;
            row-gap: 30px;
        `,
    },
};
const styles = addressPageLayoutStyles;
export const AddressPageLayout: FC<any> = ({ id }) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem width={12}>
                <XngZone contentId={id} zoneName="PageTitle" hint="PageTitle" />
            </GridItem>
            <GridItem {...styles.addressInfoGridItem} data-test-selector="Address Information">
                <XngZone contentId={id} zoneName="Addresses Information" hint="Addresses Information"/>
            </GridItem>
            <GridItem {...styles.addressBookGridItem}>
                <XngZone contentId={id} zoneName="AddressBook" hint="AddressBook" />
                <XngZone contentId={id} zoneName="AddressBookPagination" hint="AddressBookPagination" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: AddressPageLayout,
    definition: {
        group: "Xngage Custom" as any,
    },
};

export default widgetModule;
